import classNames from "classnames";

import Avatar from "components/Avatar";

import { imageUrlFor } from "lib/remoteContent";

import { parseDate } from "lib/parseDate";

import styles from "./PostDetails.module.css";

import type { BlogPost } from "lib/remoteContent";

const PostDetails: React.FC<BlogPost> = ({ authors, date }) => {
  return (
    <div className={styles.meta}>
      {authors && authors.length > 0 ? (
        <div className={classNames(styles.authors)}>
          <span className={styles.label}>Written by</span>
          {authors.map((author) => (
            <div className={classNames(styles.author, styles.metaItem)} key={author.name}>
              <Avatar
                avatar={imageUrlFor(author.avatar).width(40).url()}
                avatar_placeholder_color={"#000"}
                initials={author.name
                  .split(" ")
                  .map((part) => part[0])
                  .join("")}
              />
              <span className={styles.value}>{author.name}</span>
            </div>
          ))}
        </div>
      ) : null}

      {date ? (
        <div className={classNames(styles.metaItem, styles.date)}>
          <span className={styles.label}>Published on</span>
          <span className={styles.value}>
            {new Intl.DateTimeFormat("en-US", { dateStyle: "long" }).format(parseDate(date))}
          </span>
        </div>
      ) : null}
    </div>
  );
};

export default PostDetails;
